import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {searchBulkConsignments} from "./actions";
import ListView from "../common/ListView";
import {getBulkProducts} from "../BulkProduct/actions";
import {Link} from "react-router-dom";
import DateTimeDisplay from "../common/DateTimeDisplay";
import NormalisedQuantityDisplay from "./NormalisedQuantityDisplay";

class BulkConsignmentsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    dispensaryId: PropTypes.string,
    search: PropTypes.object.isRequired,
    bulkProducts: PropTypes.array.isRequired,
    /* actions */
    searchBulkConsignments: PropTypes.func.isRequired,
    getBulkProducts: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this.load();
  }

  load = () => {
    const {dispensaryId, getBulkProducts} = this.props;
    getBulkProducts({dispensaryId});
  };

  render() {
    const {
      history, searchBulkConsignments, dispensaryId, bulkProducts,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Received At',
        dataIndex: 'receivedAt',
        key: 'receivedAt',
        sorter: true,
        render: receivedAt => <DateTimeDisplay dateTime={receivedAt}/>,
      },
      {
        title: 'Lot Number',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        sorter: true,
      },
      {
        title: 'Bulk Product Name',
        dataIndex: 'bulkProductName',
        key: 'bulkProductId',
        sorter: true,
        className: 'truncated-column',
        filters: bulkProducts.map(p => ({text: p.name, value: p.bulkProductId})),
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        render: (qty, {receivedUnit}) => <NormalisedQuantityDisplay normalisedQuantity={qty} unit={receivedUnit}/>,
      },
      {
        title: 'Packaged',
        dataIndex: 'packagedQuantity',
        key: 'packagedQuantity',
        render: (qty, {receivedUnit}) => <NormalisedQuantityDisplay normalisedQuantity={qty} unit={receivedUnit}/>,
      },
      {
        title: 'To Package',
        dataIndex: 'remainingQuantity',
        key: 'remainingQuantity',
        render: (qty, {receivedUnit}) => <NormalisedQuantityDisplay normalisedQuantity={qty} unit={receivedUnit}/>,
        sorter: true,
      },
      {
        fixed: 'right',
        width: 80,
        title: 'Action',
        key: 'action',
        render: (_, {bulkConsignmentId}) => <Link key="packs" to={`/bulk-consignment/packs/${bulkConsignmentId}`}>Packs</Link>
      }
    ];
    return (<ListView
        dispensaryId={dispensaryId}
        title="Bulk Consignments"
        searchPlaceholder="Search product, lot, unit, unit class"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchBulkConsignments}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        scroll={{x: 1000}}
        onAdd={() => history.push('/bulk-consignment/receiveBulkProduct')}
        rowKey="bulkConsignmentId"
    />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.bulkConsignment.bulkConsignmentsLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  bulkProducts: state.bulkProduct.bulkProducts,
  search: state.bulkConsignment.search,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchBulkConsignments,
  getBulkProducts,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(BulkConsignmentsPage);



// WEBPACK FOOTER //
// ./src/BulkConsignment/BulkConsignmentsPage.js